/** The signed-in user's server tools and rank, shared by the Server settings tabs. */
import { Permissions } from '@neosocial/protocol';
import { useData, useDataShallow } from '../store/data';
import { basePermissions, can, topRolePosition, useActiveGuildId } from '../store/selectors';

/** Giving Administrator or a Manage permission needs a fresh code (the brake, section 4.5). */
export const DESTRUCTIVE = { reason: 'destructive', level: 'second_factor' } as const;

/**
 * Permissions and hierarchy rank as the server computes them (the
 * protocol's calculator and `memberTopRank`), "View server as role"
 * included: while previewing, you are not the owner.
 */
export function useAdminPerms() {
  const gid = useActiveGuildId();
  const base = useDataShallow((d) => basePermissions(d, gid));
  const isOwner = useData((d) => !!gid && d.guilds[gid]?.owner_id === d.me?.id && !d.viewAs);
  const topRank = useData((d) => (gid && d.me ? topRolePosition(d, gid, d.me.id) : 0));
  return {
    gid,
    base,
    isOwner,
    topRank,
    channels: can(base, Permissions.MANAGE_CHANNELS),
    roles: can(base, Permissions.MANAGE_ROLES),
    admin: can(base, Permissions.ADMINISTRATOR),
  };
}
